<template>
  <div v-if="visible" class="template template-receipt">
    <div class="tr-center">
      <p class="tr-shop">消费凭证</p>
      <p class="tr-no">NO. {{ orderNo }}</p>
      <p class="tr-stars">* * * * * * * *</p>
    </div>
    <div v-if="discountSummary" class="tr-discount-info">
      <span>原价 {{ discountSummary.totalOriginal }}</span>
      <span v-if="discountSummary.thresholdDiscount > 0">满减 -{{ discountSummary.thresholdDiscount }}</span>
      <span v-if="discountSummary.couponDiscount > 0">券 -{{ discountSummary.couponDiscount }}</span>
      <span class="tr-discount-final">实付 {{ discountSummary.finalTotal }}</span>
    </div>
    <div class="tr-items">
      <div v-for="(item, i) in resultList" :key="i" class="tr-row">
        <span class="tr-name">{{ item.name }}</span>
        <span class="tr-dots"></span>
        <span v-if="item.type === '应退'" class="tr-amount green">退 {{ item.finalAmount.toFixed(2) }}</span>
        <span v-else class="tr-amount red">缴 {{ item.finalAmount.toFixed(2) }}</span>
      </div>
    </div>
    <div class="tr-center">
      <p class="tr-stars">* * * * * * * *</p>
      <p class="tr-total">实付总额：{{ totalAmount }} 元</p>
      <p class="tr-total-line">====================</p>
      <p class="tr-date">{{ dateStr }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateReceipt',
  props: {
    resultList: { type: Array, default: () => [] },
    form: { type: Object, default: () => ({}) },
    visible: { type: Boolean, default: false },
    discountSummary: { type: Object, default: null }
  },
  computed: {
    orderNo() {
      return String(Date.now()).slice(-8)
    },
    dateStr() {
      return new Date().toLocaleString()
    },
    totalAmount() {
      if (this.discountSummary) return this.discountSummary.finalTotal.toFixed(2)
      return this.resultList.reduce((s, r) => s + r.payAmount, 0).toFixed(2)
    }
  }
}
</script>

<style scoped>
.template-receipt {
  width: 375px;
  background: #fffef7;
  padding: 20px;
  font-family: 'Courier New', Courier, monospace;
  color: #333;
  box-sizing: border-box;
  font-size: 13px;
  line-height: 1.8;
}

.tr-center {
  text-align: center;
}

.tr-shop {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px;
}

.tr-no {
  font-size: 11px;
  color: #999;
  margin: 0 0 6px;
}

.tr-stars {
  font-size: 11px;
  color: #ccc;
  margin: 6px 0;
}

.tr-discount-info {
  text-align: center;
  font-size: 11px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #ccc;
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.tr-discount-final {
  font-weight: 700;
  color: #333;
}

.tr-items {
  margin: 10px 0;
}

.tr-row {
  display: flex;
  align-items: baseline;
}

.tr-name {
  font-weight: 600;
  flex-shrink: 0;
}

.tr-dots {
  flex: 1;
  border-bottom: 1px dotted #ccc;
  margin: 0 6px;
  min-width: 20px;
}

.tr-amount {
  flex-shrink: 0;
  font-weight: 700;
}

.tr-amount.green {
  color: #2d8a56;
}

.tr-amount.red {
  color: #c53030;
}

.tr-total {
  font-weight: 700;
  font-size: 14px;
  margin: 6px 0 4px;
}

.tr-total-line {
  margin: 0;
  color: #666;
  font-size: 11px;
}

.tr-date {
  font-size: 11px;
  color: #999;
  margin: 4px 0 0;
}
</style>
